import { useStoreConfig } from '../context/StoreConfigContext.jsx';
import { useCopyToClipboard } from '../hooks/useCopyToClipboard.js';
import { usePlayerCount } from '../hooks/usePlayerCount.js';
import '../styles/components/SidebarStatusStyle.css';

export function SidebarStatus() {
  const { site } = useStoreConfig();
  const playerCount = usePlayerCount(site.server_ip);
  const { copy, copied } = useCopyToClipboard();

  const copyIp = () => copy(site.server_ip);

  return (
    <>
      <div className="sidebar-status">
        <button
          type="button"
          className="sidebar-ip"
          onClick={copyIp}
          aria-label="Copy server IP to clipboard"
        >
          <span className="sidebar-ip-dot" aria-hidden="true" />
          <span className="sidebar-ip-info">
            <span className="sidebar-ip-host">{site.server_ip}</span>
            <span className="sidebar-ip-meta">
              <span className="sidebar-ip-count">{playerCount}</span> online · click to copy
            </span>
          </span>
          <i className="fa-solid fa-copy sidebar-ip-copy" aria-hidden="true" />
        </button>

        <div className="sidebar-social">
          <a
            href={site.discord_url}
            className="sidebar-social-btn discord"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-discord" />
            <span>Discord</span>
          </a>
          <a
            href={site.website_url}
            className="sidebar-social-btn website"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-solid fa-globe" />
            <span>Website</span>
          </a>
        </div>
      </div>

      <div id="copy-popup" className={copied ? 'show' : undefined}>
        <i className="fa-solid fa-check" />
        IP copied to clipboard!
      </div>
    </>
  );
}
